import { render, staticRenderFns } from "./AddManagersModal.vue?vue&type=template&id=03bed7e3"
import script from "./AddManagersModal.vue?vue&type=script&lang=js"
export * from "./AddManagersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports